// JST(UTC+9)関連の日付ユーティリティ
// ブラウザのtoISOString()はUTC基準のため、日本時間の午前9時より前は
// 「当日」の日付が前日としてずれてしまう。これを避けるため、常にJST基準で算出する。
const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

// 指定日時(省略時は現在時刻)をJST基準のYYYY-MM-DD形式に変換
// monthsOffsetを指定すると、JST基準の月単位で加減算した日付を取得できる
export const getJSTDateString = (date: Date = new Date(), monthsOffset = 0): string => {
  const jst = new Date(date.getTime() + JST_OFFSET_MS);
  if (monthsOffset !== 0) {
    jst.setUTCMonth(jst.getUTCMonth() + monthsOffset);
  }
  const year = jst.getUTCFullYear();
  const month = String(jst.getUTCMonth() + 1).padStart(2, "0");
  const day = String(jst.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
